import React from 'react';
import PropTypes from 'prop-types';

import PageHeader from '../components/PageHeader';
import Album from '../components/Album';

const Photos = ({ data }) => {
  const { imagesSharp, legendsMarkdown } = data;

  const legends = legendsMarkdown.edges.reduce((memo, legend) => {
    const { node } = legend;
    const path = node.fields.slug;
    const infos = node.frontmatter;

    const repositories = path.split('/').filter(e => e !== "");

    const repository = repositories[0];
    const image = repositories[repositories.length - 1];

    const memoKeys = Object.keys(memo);

    if (memoKeys.indexOf(repository) !== -1) {
      memo[repository][image] = infos;
    } else {
      memo[repository] = [];
      memo[repository][image] = infos;
    }

    return memo;
  }, []);

  const albums = imagesSharp.edges.reduce((memo, image) => {

    const imagePath = image.node.parent.id;
    const articlePath = image.node.fields.slug;
    const repositories = imagePath.split('/');  

    const indexOfPost = repositories.indexOf('posts') + 1;
    if (indexOfPost !== 0) {
      const repository = repositories[indexOfPost];
      const postTitle = repositories[indexOfPost].replace(/_/g, ' ');

      const { src, originalName } = image.node.imageData;
      const shortName = originalName.split('.')[0];

      var description;
      const legendsKeys = Object.keys(legends);
      if (legendsKeys.indexOf(repository) !== -1) {
        const albumsLegends = Object.keys(legends[repository]);
        if (albumsLegends.indexOf(shortName) !== -1) {
          description = legends[repository][shortName]['description']; 
        }
      }

      const imageData = {
        original: src,
        thumbnail: src,
        originalTitle: originalName,
        originalAlt: originalName,
        description: description,
      };
  
      if (Object.keys(memo).indexOf(repository) !== -1) {
        memo[repository]['images'] = [...memo[repository]['images'], imageData];
      } else {
        memo[repository] = [];
        memo[repository]['postPath'] = articlePath;
        memo[repository]['postTitle'] = postTitle;
        memo[repository]['images'] = [imageData];
      }
    }

    return memo;
  }, {});

  const renderAlbums = (albums) => {
    return Object.keys(albums).map(album => {
      return (
        <Album
          key={album}
          title={albums[album]['postTitle']}
          articlePath={albums[album]['postPath']}
          images={albums[album]['images']}
        />
      );
    });
  }

  return (
    <div className="photos">
      <div className="main">
        <PageHeader title="Retrouvez ici toutes nos photos" />
      </div>

      { renderAlbums(albums) }
    </div>
  );
};

Photos.propTypes = {
  data: PropTypes.object,
};

export default Photos;

export const query = graphql`
  query allImagesQuery {
    imagesSharp: allImageSharp {
      edges {
        node {
          fields {
            slug
          }
          parent {
            id
          }
          ... on ImageSharp {
            imageData: resolutions(height: 700, width: 1400, cropFocus: CENTER) {
              src
              originalName
            }
          }
        }
      }
    }
    legendsMarkdown: allMarkdownRemark(
      filter: { fileAbsolutePath: { regex: "/images/legends/"}}
    ) {
      edges {
        node {
          id
          fields {
            slug
          }
          frontmatter {
            title
            description
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/photos.jsx